import { createFeatureSelector, createSelector } from "@ngrx/store";
import { CdrState } from "./cdr.model";

export const selectCdrState = createFeatureSelector<CdrState>('cdrs');

export const selectLoading = createSelector(
    selectCdrState,
    (state) => state.loading
)

export const selectCdrs = createSelector(
    selectCdrState,
    (state) => state.cdrs
)

export const selectCdrsPagination = createSelector(
    selectCdrState,
    (state) => state.cdrsPagination
)

export const selectCdrsCurrentFilter = createSelector(
    selectCdrState,
    (state) => state.cdrFilter
)

export const selectCdrsCurrentRequest = createSelector(
    selectCdrState,
    (state) => state.cdrRequest
)

export const selectCdrTotalCount = createSelector(
    selectCdrState,
    (state) => state.cdrsPage?.totalCount
)

export const selectCdrsFilterParameters = createSelector(
    selectCdrState,
    (state) => state.cdrFilterParameters
)

export const selectCdrMetadata = createSelector(
    selectCdrState,
    (state) => state.cdrMetadata
)